const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.867 21.867c-.843.843-1.6 2.133-1.6 3.2V27.2H12.8v-2.666h-2.133c-1.067 0-1.788-.591-2.134-1.6-.533-1.556-1.066-3.2-1.066-3.2H6.4c-1.066 0-.921-.953-.533-1.6 1.6-2.667 1.6-3.2 1.6-4.267 0-5.36 4.267-8.533 8.533-8.533 5.334 0 9.6 2.666 9.6 8.533 0 4.267-2.133 6.4-3.733 8M16 0c8.837 0 16 7.164 16 16 0 8.837-7.163 16-16 16-8.836 0-16-7.163-16-16C0 7.164 7.164 0 16 0zm1.066 18.133h-2.133v1.6h2.133zm-.774-7.987c-.903 0-1.635.222-2.198.664a2.483 2.483 0 00-.939 1.99h1.778c.005-.369.319-.685.542-.877.223-.191.496-.286.817-.286.391 0 .691.113.901.339.211.225.316.538.316.937 0 .36-.092.686-.277.977-.184.291-.507.508-.815.76-.525.404-.953.8-1.128 1.082-.176.282-.351.727-.356 1.335h2.133c0-.361.042-.644.124-.85.083-.206.256-.411.521-.615.486-.317.916-.65 1.239-1.119.323-.468.533-1.038.533-1.59 0-.846-.28-1.567-.833-2.06-.554-.492-1.386-.687-2.358-.687z"
});

const SvgThink2 = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#6fdcf8",
    fillRule: "evenodd",
    height: 32,
    width: 32,
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgThink2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/think2.04ae7bd9.svg";
export { ForwardRef as ReactComponent };